export const PRESENTPLATE = "PRESENTPLATE"
export const PRESENTPLATEDELETE = "PRESENTPLATEDELETE"
export const FIXEDPLATE = "FIXEDPLATE"
export const VEHICLEOWNERLIST = "VEHICLEOWNERLIST"
export const FIXEDPLATELIST = "FIXEDPLATELIST"
export const FIXEDPLATEUPDATE = "FIXEDPLATEUPDATE"
export const FIXEDPLATEADD = "FIXEDPLATEADD"
export const FIXEDPLATECHARGE = "FIXEDPLATECHARGE"
export const FIXEDPLATEDELETE = "FIXEDPLATEDELETE"
export const BLACKLIST = "BLACKLIST"
export const DELETEBLACKLIST = "DELETEBLACKLIST"
export const ADDBLACKLIST = "ADDBLACKLIST"
export const CHARGETOTAL = "CHARGETOTAL"
export const OPENGATERECORD = "OPENGATERECORD"
export const PAYRECORD = "PAYRECORD"
export const RECHARGERECORD = "RECHARGERECORD"
export const RECHARGERECORDTOTAL = "RECHARGERECORDTOTAL"
export const UNPAIDRECORD = "UNPAIDRECORD"
export const REPASSWORD = "REPASSWORD"

export const BUSINESSQUERY = "BUSINESSQUERY"
export const BUSINESSUPDATE = "BUSINESSUPDATE"
export const BUSINESSDELETE = "BUSINESSDELETE"
export const BUSINESSCHARGE = "BUSINESSCHARGE"
export const BUSINESSSELECT = "BUSINESSSELECT"
export const BUSINESSRECHARGEQUERY = "BUSINESSRECHARGEQUERY"

export const COUPONSUSEQUERY = "COUPONSUSEQUERY"
export const COUPONSQUERY = "COUPONSQUERY"
export const COUPONSADD = "COUPONSADD"
export const COUPONSUPDATE = "COUPONSUPDATE"
export const COUPONSDELETE = "COUPONSDELETE"

export const USERQUERY = "USERQUERY"
export const USERADD = "USERADD"
export const USERUPDATE = "USERUPDATE"
export const USERDELETE = "USERDELETE"

export const PARKINGLOTCONFIGQUERY = "PARKINGLOTCONFIGQUERY"
export const PARKINGLOTCONFIGUPDATE = "PARKINGLOTCONFIGUPDATE"




// WEBPACK FOOTER //
// ./src/store/app/mine/types.js